import React from 'react'
 
export default class ImageBackground extends React.Component {
    render() {
        const { source, style, imageStyle, ...props } = this.props
        const { resizeMode, ...style2 } = imageStyle

        switch (resizeMode) {
            case 'cover': 
                style.backgroundSize = 'cover'
                style.backgroundRepeat = 'no-repeat'
                break;
            case 'repeat': 
                break;
        }

        return <div style={{ ...style2, ...style, backgroundImage: `url(${source})` }} {...props} />
    }
}
 
